export default "__VITE_ASSET__CxafjzQ$__"